module.exports = __webpack_public_path__ + "static/media/ca-labs-logo.f6705e51.png";